import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  getAppExecuteInfo(objId) {
    return axios.get(`${baseUrl}/common/app/get-app-execute-info.do`, {
      params: {
        objId,
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/common/app.js